import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthProvider";

import axios from "axios";

const useFileUploadsFromActiveLicenses = (slug?: string) => {
    const user = useContext(AuthContext);
    const [fileUploadsFromActiveLicenses, setFileUploadsFromActiveLicenses] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const result = await axios.get('/api/v1/syllabus/user_file_upload/active-license-uploads/', {
                    headers: {
                        'X-CSRFToken': JSON.parse(
                            document.getElementById('csrf_token')!.innerHTML,
                        ),
                    },
                    params: {
                        slug: slug
                    }
                });
                if (result.data) {
                    const sortedFileUploads = result.data
                    .sort((a: any, b: any) => a.actual_student_school_name.localeCompare(b.actual_student_school_name))
                    setFileUploadsFromActiveLicenses(sortedFileUploads);
                    setIsLoading(false);
                }
            } catch (error) {
                console.error("Error fetching file uploads:", error);
                setError("Error fetching file uploads - " + JSON.stringify(error));
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    return {
        fileUploadsFromActiveLicenses,
        isLoading,
        error
    };
};

export default useFileUploadsFromActiveLicenses;
